import { AlertTriangle } from "lucide-react";

const cm = (v) => `${Math.abs(Number(v)).toFixed(1)} cm`;

// "How you like your shoes to fit", from `fit_preference` + `fit_allowance_cm`.
export function fitPreferenceText(pref, allowance) {
  if (pref === "roomy") {
    return allowance != null ? `You like extra room, about ${cm(allowance)}.` : "You like extra room.";
  }
  if (pref === "true") return "You fit the size as printed.";
  if (pref === "snug") return "You like a close fit.";
  return "";
}

export default function FitPreference({ fitkey, testid = "fit-preference", className = "" }) {
  if (!fitkey) return null;
  const text = fitPreferenceText(fitkey.fit_preference, fitkey.fit_allowance_cm);
  return (
    <div className={className}>
      {text ? (
        <div
          data-testid={testid}
          className="flex items-start gap-3 rounded-2xl border border-black/10 bg-white px-4 py-3.5"
        >
          <span className="mt-[3px] h-2 w-2 rounded-full bg-[#0A0A0A] shrink-0" />
          <div>
            <div className="text-[10.5px] uppercase tracking-[0.2em] text-neutral-500">Your fit</div>
            <div data-testid={`${testid}-text`} className="mt-1 text-[14.5px] text-[#0A0A0A]">
              {text}
            </div>
          </div>
        </div>
      ) : (
        <div data-testid={`${testid}-missing`} className="text-[12.5px] text-neutral-500">
          {fitkey.foot_length_cm != null
            ? "Your measurements are saved. Your fit preference appears once we have the size chart for this exact size."
            : "Add your foot length to see how you like your shoes to fit."}
        </div>
      )}
      {fitkey.reference_check === "unusual" && (
        <div
          data-testid={`${testid}-unusual`}
          className="mt-2.5 flex items-start gap-2 rounded-xl bg-amber-50 border border-amber-200/70 px-3.5 py-2.5 text-[12.5px] text-amber-800"
        >
          <AlertTriangle className="h-3.5 w-3.5 mt-[2px] shrink-0" />
          Your reference size looks unusual for your foot, double-check it.
        </div>
      )}
    </div>
  );
}

// The backend's private `foot_length_cm` is the length used for sizing
// (measured foot + clamped fit allowance). Recover the measured foot for display.
export function measuredFootLength(fk) {
  if (!fk || fk.foot_length_cm == null) return null;
  if (fk.fit_allowance_cm == null) return fk.foot_length_cm;
  const allow = Math.max(-1.5, Math.min(2.0, fk.fit_allowance_cm));
  return Math.round((fk.foot_length_cm - allow) * 10) / 10;
}
